import { render } from "./EmbeddableReports.vue?vue&type=template&id=07df9b14&scoped=true&ts=true"
import script from "./EmbeddableReports.vue?vue&type=script&lang=ts"
export * from "./EmbeddableReports.vue?vue&type=script&lang=ts"

import "./EmbeddableReports.vue?vue&type=style&index=0&id=07df9b14&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07df9b14"]])

export default __exports__